import { useEffect } from 'react';

export const useScrollHorizontalInfiniteCarouse = (
  wrapperScroll,
  containerItems,
) => {
  const handleScroll = () => {
    wrapperScroll.current.addEventListener('scroll', horizontalInfiniteCarouse);
  };

  const horizontalInfiniteCarouse = () => {
    const factor =
      wrapperScroll.current.scrollLeft /
      (wrapperScroll.current.scrollWidth - wrapperScroll.current.clientWidth);

    if (factor < 0.2) {
      const move = containerItems.current.lastElementChild;

      containerItems.current.prepend(move);
      wrapperScroll.current.scrollLeft += move.clientWidth;
    } else if (factor > 0.8) {
      const move = containerItems.current.firstElementChild;
      containerItems.current.appendChild(move);
      wrapperScroll.current.scrollLeft -= move.clientWidth;
    }
  };

  useEffect(
    () => {
      if (wrapperScroll?.current && containerItems?.current) {
        handleScroll();
      }

      return () => {
        if (wrapperScroll.current) {
          wrapperScroll.current.removeEventListener(
            'scroll',
            horizontalInfiniteCarouse,
          );
        }
      };
    },
    [wrapperScroll?.current, containerItems?.current],
  );
};
